// extracted by mini-css-extract-plugin
module.exports = {"container":"AddNoteOption__container--3j8nZ3Ygbz","add-note":"AddNoteOption__add-note--3JxbjTxHsJ","add-note__text":"AddNoteOption__add-note__text--3ms_UBWBuj"};